import React, { useContext, useEffect, useRef, useState } from 'react'
import './SuccessComponent.css'
import { CircularProgress } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { set_image_upload_status } from '../../store/image_upload'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import FileContext from '../../context/Context'
import CloseIcon from '@mui/icons-material/Close'
import ProgressBar from './ProgressBar'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const ProcessingVideo = () => {
  const { audit_id } = useParams()
  const [isPopupOpen, setPopupOpen] = useState(false)
  const [ratingSucceeded, setRatingSucceded] = useState(false)
  const [rating, setRating] = useState(0)
  const [qualityCheck, setQualityCheck] = useState(false)
  const [reportGeneration, setReportGeneration] = useState(false)
  const [uploadProgress, setUploadProgress] = useState(0) // New state for upload progress
  const [isSubmittingRating, setIsSubmittingRating] = useState(false)
  const [emailSent, setEmailSent] = useState(false)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { capturedVideo } = useContext(FileContext)
  const { auditID } = useSelector(state => state.imagesStore)

  // Auto-trigger rating popup when both steps are complete
  useEffect(() => {
    if (qualityCheck) {
      setPopupOpen(true)
      setRating(5) // Auto-select 5 stars
    }
  }, [qualityCheck])

  const sendEmailNotification = async auditId => {
    try {
      const checkResponse = await axios.post('/rating/check-hyundai-audit', {
        auditId: auditId
      })

      const isHyundai = checkResponse?.data?.isHyundai

      const emailResponse = await axios.post(
        '/rating/send-upload-complete-email',
        {
          audit_id: auditId,
          status: 'upload_complete',
          message: isHyundai
            ? 'Audit completed successfully in video mode (HYUNDAI)'
            : 'Audit completed successfully in video mode'
        }
      )

      if (emailResponse.status === 200 || emailResponse.status === 201) {
        console.log('Email notification sent successfully')
        setEmailSent(true)
      }
    } catch (error) {
      console.error('Error sending email notification:', error)
    }
  }

  // const uploadVideoToServer = async (fileName, videoBlob) => {
  //     try {
  //         const formData = new FormData();
  //         formData.append('file', videoBlob, fileName);
  //         formData.append('blobName', `Insurance_Inspection/auditVideos/${fileName}`);

  //         await axios.post('/process_data/upload_video_to_s3', formData, {
  //             headers: {
  //                 'Content-Type': 'multipart/form-data'
  //             },
  //             onUploadProgress: (progressEvent) => {
  //                 if (progressEvent.lengthComputable) {
  //                     const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
  //                     console.log(`Upload progress: ${percentCompleted}%`);
  //                     setUploadProgress(percentCompleted);
  //                 }
  //             }
  //         });

  //         console.log('Upload successful');
  //     } catch (error) {
  //         console.error('Error uploading video:', error);
  //          throw error;
  //     }
  // };
  const uploadVideoToServer = async (fileName, videoBlob) => {
    const MAX_RETRIES = 3

    for (let attempt = 1; attempt <= MAX_RETRIES; attempt++) {
      try {
        console.log(`🔄 Upload attempt ${attempt}/${MAX_RETRIES}`)

        const formData = new FormData()
        formData.append('file', videoBlob, fileName)
        formData.append(
          'blobName',
          `Insurance_Inspection/auditVideos/${fileName}`
        )

        await axios.post('/process_data/upload_video_to_s3', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: progressEvent => {
            if (progressEvent.lengthComputable) {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              )
              setUploadProgress(percentCompleted)
            }
          }
        })

        console.log('✅ Upload successful')
        return // EXIT function — no more retries needed
      } catch (error) {
        console.error(`❌ Upload attempt ${attempt} failed`, error)

        if (attempt === MAX_RETRIES) {
          console.error('🚨 All upload attempts failed.')
          throw error // IMPORTANT — stops next steps
        }

        // Wait 1 second before retrying
        await new Promise(res => setTimeout(res, 1000))
      }
    }
  }

  const [processingAi, setProcessingAi] = useState(false)
  const processVideos = async auditId => {
    console.log('200-processvdo')
    try {
      const response = await axios.post('/video_automation/process-videos', {
        auditId: auditId
      })

      console.log('response', response.data)

      if (response.data.success) {
        console.log('✅ Processing completed:', response.data.message)
      } else {
        console.warn('⚠️ Processing failed:', response.data.error)
      }

      await sendEmailNotification(auditId)
    } catch (error) {
      console.error('❌ Error during video processing:', error.message)

      // Still send email even if API failed
      try {
        await sendEmailNotification(auditId)
      } catch (emailErr) {
        console.error('❌ Error sending email:', emailErr.message)
      }
    } finally {
      setTimeout(() => {
        setQualityCheck(true)
      }, 1000)

      setProcessingAi(false)
    }
  }

  const hasRun = useRef(false)
  useEffect(() => {
    if (!capturedVideo?.length) return

    const handleProceed = async () => {
      if (hasRun.current) return // ✅ Prevent duplicate calls
      hasRun.current = true

      const fileName = `${audit_id}_video.mp4`
      try {
        setProcessingAi(true)

        await uploadVideoToServer(fileName, capturedVideo[0])
        // Start processing first
        await processVideos(audit_id)
        console.log("184")
        // THEN update DB
        await axios.post('/create_audit/update_token', {
          audit: audit_id,
          processed: 1,
          status: 'processing'
        })

        
      } catch (err) {
        console.error('❌ Error in handleProceed:', err)
        setProcessingAi(false)
        return
      }
    }

    handleProceed()
  }, [capturedVideo])

  console.log(capturedVideo, '68')
  const handleButtonClick = () => {
    setPopupOpen(true)
  }

  const handleClosePopup = () => {
    setPopupOpen(false)
  }

  const handleStarClick = star => {
    setRating(star)
  }
  // const handleSubmit = () => {
  //     setRatingSucceded(true)
  // }

  const handleSubmit = async () => {
    if (rating === 0) return

    setIsSubmittingRating(true)
    console.log('Rating being sent:', rating)
    try {
      // API call to save rating
      const response = await axios.post('/rating/save-rating', {
        audit: audit_id,
        Rating: rating
      })
      console.log(`Saving rating: ${rating} stars for audit ID: ${audit_id}`)
      if (response.status === 200 || response.status === 201) {
        console.log('Rating saved successfully:', response.data)
        console.log(`${rating} star rating saved for audit: ${audit_id}`)
        setRatingSucceded(true)
        toast.success(`${rating} star rating saved successfully!`, {
          position: 'bottom-right',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true
        })
      }
    } catch (error) {
      console.error('Error saving rating:', error)
      toast.error('Failed to save rating. Please try again.', {
        position: 'bottom-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      })
    } finally {
      setIsSubmittingRating(false)
    }
  }

  const check = `${process.env.PUBLIC_URL}/custom-icons/timer.png`
  const timer = `${process.env.PUBLIC_URL}/inspection-images/check-icon.png`
  const star = `${process.env.PUBLIC_URL}/inspection-images/star.png`
  const step1_pink = `${process.env.PUBLIC_URL}/custom-icons/step1-pink.svg`
  const step2_grey = `${process.env.PUBLIC_URL}/custom-icons/step2-grey.svg`
  const step3_grey = `${process.env.PUBLIC_URL}/custom-icons/step3-grey.png`
  const step2_pink = `${process.env.PUBLIC_URL}/custom-icons/step2-pink.png`
  const step3_pink = `${process.env.PUBLIC_URL}/custom-icons/step3-pink.png`
  const close = `${process.env.PUBLIC_URL}/custom-icons/close.png`
  const success = `${process.env.PUBLIC_URL}/inspection-images/success-background.png`
  const starEmpty = `${process.env.PUBLIC_URL}/inspection-images/image.png`
  const starFilled = `${process.env.PUBLIC_URL}/inspection-images/star-filled.png`

  useEffect(() => {
    if (qualityCheck) {
      toast.success('Inspection is complete! You can close now.', {
        position: 'bottom-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { fontSize: '10px' } // Reducing the font size
        // progressStyle: { backgroundColor: '#ff0083' } // Changing progress bar color
      })
    }
  }, [qualityCheck])
  const closeTab = () => {
    console.log('close')
    navigate('/login')
  }

  return (
    <>
      <div className='success-container'>
        <div className='illustration-section'>
          <img src={success} alt='Success Illustration' />
        </div>
        <div className='content-section'>
          <div className='check-icon'>
            <img src={check} alt='Check Icon' />
          </div>
          {/* <h2>Processing</h2> */}
          {/* <p>We are processing the inspection. Keep the window open.</p> */}
          {!qualityCheck && (
            <>
              <h2>Processing</h2>
              <p>We are processing the inspection. Keep the window open.</p>
            </>
          )}
          {qualityCheck && (
            <>
              <h2>Processed</h2>
              <p>
                Inspection <strong>{auditID}</strong> is completed! You can
                close the window now
              </p>
            </>
          )}
          <ol className='steps-list'>
            <li className='step'>
              <span className='step-number-audit'>
                <img src={step1_pink} alt='Step 1' />
              </span>
              Quality Check
              <span className='vertical-line'></span>
              <br />
              <div className='progress-container'>
                <ProgressBar percentage={uploadProgress} />
              </div>
              {!qualityCheck && (
                <div className='upload-status'>
                  {uploadProgress === 100 ? 'Upload Complete' : 'Uploading'}
                </div>
              )}
            </li>
            {/* <li className="step">
                            <span className="step-number-audit">
                                {qualityCheck ? (
                                    <img src={step2_pink} alt="Step 2" />
                                ) : (
                                    <img src={step2_grey} alt="Step 2" />
                                )}
                            </span>
                            Report Generation
                            <span className="vertical-line2"></span>
                            <ToastContainer />
                        </li> */}
            <li className='step'>
              <span className='step-number-audit'>
                {qualityCheck ? (
                  <img src={step2_pink} alt='Step 2' />
                ) : (
                  <img src={step2_grey} alt='Step 2' />
                )}
              </span>
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
              >
                Report Generation
                {uploadProgress === 100 &&
                  !qualityCheck &&
                  !reportGeneration &&
                  processingAi && <span className='spinner-icon' />}
              </div>
              <span className='vertical-line2'></span>
              <ToastContainer />
            </li>

            <li className='step disabled-step'>
              <span className='step-number-audit'>
                {reportGeneration ? (
                  <img src={step3_pink} alt='Step 3' />
                ) : (
                  <img src={step3_grey} alt='Step 3' />
                )}
              </span>
              Report Submission
            </li>
          </ol>
          {/* <button
                        disabled={processingAi}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "0.2rem",
                            border: "1.5px solid #FF0083",
                            padding: "0rem 1rem",
                            backgroundColor: processingAi ? "#f0f0f0" : "white",
                            borderRadius: "3px",
                            opacity: processingAi ? 0.5 : 0.9,
                            width: "100%",
                            cursor: processingAi ? "not-allowed" : "pointer"
                        }}
                        onClick={closeTab}
                    >
                        <span
                            style={{
                                fontSize: "0.9rem",
                                fontFamily: "'Montserrat', sans-serif",
                                color: "#FF0083",
                                padding: "0.5rem",
                                display: "flex",
                                alignItems: "center",
                                gap: "0.4rem"
                            }}
                        >
                            {processingAi ? (
                                <>
                                    <span className="spinner-icon" />
                                    Processing — please wait..
                                </>
                            ) : (
                                'Close'
                            )}
                        </span>

                    </button> */}
        </div>
        <button className='rate-experience-btn' onClick={handleButtonClick}>
          <img src={star} alt='Star Icon' /> RATE EXPERIENCE
        </button>
      </div>

      {isPopupOpen && !ratingSucceeded && (
        <div className='popup-overlay'>
          <div className='popup-content'>
            <div className='close-popup' onClick={handleClosePopup}>
              <CloseIcon />
            </div>

            <div className='rating-heading'>
              <h4>How was your experience?</h4>
            </div>
            <p>Please share with us your feedback:</p>
            <div className='rating-stars'>
              {[1, 2, 3, 4, 5].map(starIndex => (
                <img
                  key={starIndex}
                  src={starIndex <= rating ? starFilled : starEmpty}
                  alt={`Star ${starIndex}`}
                  className='star-icon'
                  onClick={() => handleStarClick(starIndex)}
                />
              ))}
            </div>
            <button
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.2rem',
                border:
                  rating != 0 ? '1.5px solid #FF0083' : '1.5px solid #0000003D',
                padding: '0rem 1rem',
                backgroundColor: rating != 0 ? '#FF0083' : '#dcdcdc',
                color: rating != 0 ? '#ffffff' : '#0000003D',
                borderRadius: '3px',
                opacity: '0.9',
                width: '100%',
                marginTop: '0.5rem'
              }}
              // disabled={rating != 0 ? false : true}
              disabled={rating === 0 || isSubmittingRating}
              onClick={handleSubmit}
            >
              <p
                style={{
                  fontSize: '0.9rem',
                  fontFamily: "'Montserrat', sans-serif",
                  //   color: "#FF0083",
                  color: rating != 0 ? '#ffffff' : '#0000003D',
                  padding: '0.5rem',
                  cursor: 'pointer'
                }}
              >
                {isSubmittingRating ? 'Submitting...' : 'Submit'}
                {/* Submit */}
              </p>
            </button>

            {/* <p>Your rating: {rating} {rating > 1 ? 'stars' : 'star'}</p> */}
          </div>
        </div>
      )}
      {isPopupOpen && ratingSucceeded && (
        <div className='popup-overlay'>
          <div className='popup-content-after-rating'>
            <div className='close-popup' onClick={handleClosePopup}>
              <CloseIcon />
            </div>

            <div className='rating-heading-completion'>
              <h4>Thank you for sharing your feedback</h4>
            </div>
            <p style={{ textAlign: 'center' }}>
              Now You Can Close The Browser.
            </p>

            {/* <p>Your rating: {rating} {rating > 1 ? 'stars' : 'star'}</p> */}
          </div>
        </div>
      )}
    </>
  )
}

export default ProcessingVideo
